import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { googleMapsLoadStateUpdated } from 'app/store/actions/maps.actions';
import { AppState, Store } from 'app/store/states/app.state';
import { environment } from 'environments/environment.e2e';
import { catchError, map, of, switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapService {

  constructor(
    private httpClient: HttpClient,
    private store: Store<AppState>
  ) { }

  initGoogleMapsApi() {
    return this.store.select('googleMapsLoaded').pipe(
      switchMap(isLoaded => {
        if (isLoaded) return of(true);
        return this.fetchMapsLibrary();
      }),
      tap(isGoogleMapsLoaded => {
        this.store.dispatch(googleMapsLoadStateUpdated({ isGoogleMapsLoaded }))
      })
    );
  }

  // fetching all the libraries we use whenever we use the map. this could be more efficient, as we only use places on the questionaire
  //  and drawing on the polygonmap. the difficulty is google throws an error when fetching the api script more than once.
  // we would want to remove and reload the api script, but only when the libraries we are using change
  private fetchMapsLibrary() {
    return this.httpClient.jsonp(
      `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiToken}&libraries=drawing,places`,
      'callback'
    ).pipe(
      map(() => true),
      catchError(() => of(false)),
    );
  }
}
